module.exports = __webpack_public_path__ + "static/media/mastercard_logo.833c4b94.png";